export default "__VITE_ASSET__GuaDy2SK__"